export const SERVICE_DESK_FALLBACK_EMAIL =
  "rb2-nl-91b404be4432@inbound.incident.io";
